var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7075",
    "data-name": "Rectangle 7075",
    width: 380,
    height: 160,
    transform: "translate(726 381)",
    fill: "#efefef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "report_card_as_lost_or_stolen",
    "data-name": "report card as lost or stolen",
    transform: "translate(-726 -381)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28165",
    "data-name": "Group 28165",
    transform: "translate(-1.194 1.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28080",
    "data-name": "Group 28080",
    transform: "translate(842.965 446.783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28079",
    "data-name": "Group 28079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28058",
    "data-name": "Group 28058",
    transform: "translate(28.734 19.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31153",
    "data-name": "Path 31153",
    d: "M-2025.843-4696.317c-.142,0-.287,0-.413.012v-.793a.708.708,0,0,0,.036.213.226.226,0,0,0,.024.1.945.945,0,0,0,.1.19c.012.012.012.024.024.024a.5.5,0,0,0,.119.142A.608.608,0,0,0-2025.843-4696.317Z",
    transform: "translate(2026.256 4697.098)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28059",
    "data-name": "Group 28059",
    transform: "translate(28.731 19.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31154",
    "data-name": "Path 31154",
    d: "M-2025.963-4696.435a.575.575,0,0,0,.118.118c-.141,0-.287,0-.413.012v-.793a.668.668,0,0,0,.036.213.216.216,0,0,0,.023.1.958.958,0,0,0,.1.191c.011.012.011.023.023.023A.479.479,0,0,0-2025.963-4696.435Z",
    transform: "translate(2026.259 4697.098)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31155",
    "data-name": "Path 31155",
    d: "M-2025.482-4696.282a.828.828,0,0,0,0,.237l-.106-.059a1.816,1.816,0,0,1-.237-.178A3.342,3.342,0,0,1-2025.482-4696.282Z",
    transform: "translate(2026.241 4697.063)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28060",
    "data-name": "Group 28060",
    transform: "translate(28.734 19.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31156",
    "data-name": "Path 31156",
    d: "M-2025.843-4696.317c-.142,0-.287,0-.413.012v-.793a.708.708,0,0,0,.036.213.226.226,0,0,0,.024.1.945.945,0,0,0,.1.19c.012.012.012.024.024.024a.5.5,0,0,0,.119.142A.608.608,0,0,0-2025.843-4696.317Z",
    transform: "translate(2026.256 4697.098)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28061",
    "data-name": "Group 28061",
    transform: "translate(53.52 23.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31157",
    "data-name": "Path 31157",
    d: "M-2000.162-4693.294v.164a.255.255,0,0,0-.1-.022.253.253,0,0,0-.1-.024l.1-.06A.75.75,0,0,0-2000.162-4693.294Z",
    transform: "translate(2000.353 4693.294)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28062",
    "data-name": "Group 28062",
    transform: "translate(53.52 23.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31158",
    "data-name": "Path 31158",
    d: "M-2000.162-4693.294v.164a.255.255,0,0,0-.1-.022.253.253,0,0,0-.1-.024l.1-.06A.75.75,0,0,0-2000.162-4693.294Z",
    transform: "translate(2000.353 4693.294)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28063",
    "data-name": "Group 28063",
    transform: "translate(53.612 23.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31159",
    "data-name": "Path 31159",
    d: "M-2000.161-4693.294v.164a.255.255,0,0,0-.1-.022v-.083A.743.743,0,0,0-2000.161-4693.294Z",
    transform: "translate(2000.257 4693.294)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28064",
    "data-name": "Group 28064",
    transform: "translate(53.521 23.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31160",
    "data-name": "Path 31160",
    d: "M-2000.256-4693.233v.082a.287.287,0,0,0-.1-.022Z",
    transform: "translate(2000.352 4693.233)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28065",
    "data-name": "Group 28065",
    transform: "translate(28.722 13.701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31161",
    "data-name": "Path 31161",
    d: "M-2000.617-4694.679v.013a.893.893,0,0,1-.048.248v.012a1.685,1.685,0,0,1-.13.236.033.033,0,0,1-.012.023,1.052,1.052,0,0,1-.191.2,1.739,1.739,0,0,1-.287.212.69.69,0,0,1-.1.06l-.1.06h-.011l-2.316,1.322-5.716,3.27a3.69,3.69,0,0,1-3.389.048l-10.2-5.977-2.4-1.406a.772.772,0,0,1,0-.236,3.337,3.337,0,0,0-.342,0,.541.541,0,0,1-.118-.118.459.459,0,0,1-.119-.143c-.011,0-.011-.01-.024-.023a.9.9,0,0,1-.1-.191.221.221,0,0,1-.024-.1.669.669,0,0,1-.036-.213,1.206,1.206,0,0,1,.756-1l5.2-2.987,2.929-1.677a3.753,3.753,0,0,1,3.4-.036l4.976,2.917,7.736,4.523A1.17,1.17,0,0,1-2000.617-4694.679Z",
    transform: "translate(2026.269 4703.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31162",
    "data-name": "Path 31162",
    d: "M-2025.482-4696.281a.821.821,0,0,0,0,.236l-.106-.059a1.853,1.853,0,0,1-.237-.177A2.865,2.865,0,0,1-2025.482-4696.281Z",
    transform: "translate(2026.25 4703.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28066",
    "data-name": "Group 28066",
    transform: "translate(21.118)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31163",
    "data-name": "Path 31163",
    d: "M-1948.973-4689.07l-28.9,4.523a34.936,34.936,0,0,0-10.621-9,64.249,64.249,0,0,0-20.86-7.228l-4.976-2.917a3.751,3.751,0,0,0-3.4.035l-2.929,1.677a89.426,89.426,0,0,0-13.557.5l25.463-14.785a13.9,13.9,0,0,1,12.659,0Z",
    transform: "translate(2034.215 4717.788)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28067",
    "data-name": "Group 28067",
    transform: "translate(77.484 38.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31164",
    "data-name": "Path 31164",
    d: "M-1975.3-4678.027v.1c0-.014,0-.024-.011-.024v-.059Z",
    transform: "translate(1975.309 4678.027)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28068",
    "data-name": "Group 28068",
    transform: "translate(56.129 33.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31165",
    "data-name": "Path 31165",
    d: "M-1972.137-4671.993c.011-.024,0-.059,0-.082v-.083c-.013-.061-.013-.107-.024-.165v-.083c-.012-.107-.012-.213-.023-.307v-.013c-.025-.225-.048-.437-.071-.662-.012-.046-.012-.095-.023-.152-.012-.106-.024-.2-.036-.308a2.779,2.779,0,0,0-.059-.319c-.024-.165-.059-.331-.1-.5-.012-.06-.024-.129-.035-.191-.023-.082-.036-.178-.059-.272a3.962,3.962,0,0,0-.1-.389c-.024-.105-.058-.213-.082-.318-.012-.024-.012-.047-.024-.072-.024-.083-.048-.178-.071-.272s-.059-.177-.083-.271c-.036-.119-.071-.236-.118-.367v-.023a.035.035,0,0,1-.012-.024c-.012-.045-.034-.105-.048-.154a.548.548,0,0,0-.058-.153,1.817,1.817,0,0,0-.1-.272c-.011-.011-.011-.036-.024-.046-.013-.037-.024-.06-.036-.1a1.146,1.146,0,0,0-.059-.167.877.877,0,0,0-.047-.152l-.013-.013c0-.011,0-.011-.011-.011-.047-.118-.1-.237-.142-.355l-.071-.178a1.246,1.246,0,0,0-.083-.177v-.011c-.105-.238-.211-.484-.33-.722v-.011l-.012-.013c-.059-.118-.119-.236-.177-.354l-.178-.354-.012-.013c-.011-.012-.011-.022-.024-.036-.071-.142-.154-.271-.224-.4a2.88,2.88,0,0,1-.142-.272.011.011,0,0,1-.012-.011h0c-.059-.106-.118-.2-.177-.294l-.106-.179a.077.077,0,0,0-.024-.047.087.087,0,0,1-.023-.048.1.1,0,0,1-.036-.071.164.164,0,0,0-.034-.047.189.189,0,0,0-.035-.048v-.011l-.012-.012-.011-.013a.2.2,0,0,0-.048-.082.22.22,0,0,0-.048-.071v-.013c-.011-.012-.023-.036-.035-.047a.014.014,0,0,1-.011-.013h0c-.1-.153-.191-.286-.3-.437l-.013-.012c0-.012,0-.012-.011-.023s-.012-.024-.024-.036a.81.81,0,0,0-.1-.129c0-.012-.011-.012-.011-.023a.23.23,0,0,0-.048-.072c0-.013-.011-.023-.024-.036s-.024-.012-.024-.023a.064.064,0,0,0-.035-.048c-.01-.012-.024-.035-.035-.047s0-.011-.012-.023c-.048-.07-.107-.154-.166-.225,0-.012-.011-.023-.024-.034a.287.287,0,0,1-.036-.06l-3.909.614-3.141.5-14.277,30.932,1.747,1,4,2.313c1.584-.721,3.094-1.512,4.525-2.336,7.439-4.287,12.27-9.666,14.231-15.366.011-.035.023-.071.035-.105s.024-.06.035-.1c.059-.176.119-.365.166-.542a.865.865,0,0,0,.048-.155c.035-.1.059-.2.082-.3a.04.04,0,0,0,.013-.035c0-.012.011-.036.011-.047s.011-.023.011-.035a.3.3,0,0,0,.023-.1c0-.023.011-.059.011-.083s.013-.011.013-.022a.045.045,0,0,1,.01-.024.066.066,0,0,0,.011-.046v-.024c.011-.059.036-.129.048-.191.047-.237.1-.473.14-.7.036-.165.06-.331.1-.5l.011-.012c-.011-.012-.011-.012,0-.024-.011-.024,0-.045.012-.072-.012-.01,0-.023,0-.035a.206.206,0,0,0,.011-.082c0-.024.011-.035.011-.059a.14.14,0,0,0,.013-.071v-.178c.047-.259.071-.5.106-.756,0-.034.011-.069.011-.106v-.083c.023-.225.034-.437.047-.662.012-.142.012-.306.012-.436v-.225C-1972.125-4671.453-1972.125-4671.725-1972.137-4671.993Zm-4.122-6.153c0-.014,0-.024-.012-.024v-.06l.012-.012Z",
    transform: "translate(1997.627 4683.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31166",
    "data-name": "Path 31166",
    d: "M-1975.3-4678.027v.1c0-.014,0-.024-.011-.024v-.059Z",
    transform: "translate(1996.665 4682.842)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28069",
    "data-name": "Group 28069",
    transform: "translate(77.46 28.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31167",
    "data-name": "Path 31167",
    d: "M-1974.754-4682.235v.01l-.011-.01c0-.014,0-.014-.012-.024h.012C-1974.765-4682.249-1974.754-4682.249-1974.754-4682.235Z",
    transform: "translate(1975.31 4687.539)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31168",
    "data-name": "Path 31168",
    d: "M-1974.288-4681.536v.012l-.012-.012a.182.182,0,0,0-.048-.082A.2.2,0,0,1-1974.288-4681.536Z",
    transform: "translate(1975.292 4687.511)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31169",
    "data-name": "Path 31169",
    d: "M-1974.273-4681.52v.011l-.012-.011Z",
    transform: "translate(1975.289 4687.507)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31170",
    "data-name": "Path 31170",
    d: "M-1973.431-4680.035c-.012-.01-.012-.022-.024-.035-.071-.142-.154-.272-.224-.4q-.077-.133-.141-.271a.013.013,0,0,1-.012-.013h0c-.059-.105-.118-.2-.177-.294l-.106-.179a.083.083,0,0,0-.024-.047.085.085,0,0,1-.023-.046.1.1,0,0,1-.036-.073l.025.024c.048.1.106.192.164.288.036.046.059.105.1.153a1.814,1.814,0,0,1,.119.2c.1.166.2.343.288.52A.277.277,0,0,1-1973.431-4680.035Z",
    transform: "translate(1975.285 4687.502)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31171",
    "data-name": "Path 31171",
    d: "M-1972.647-4678.512l-.024.012h-.012v-.012c-.105-.237-.212-.484-.33-.722v-.011l-.012-.013c-.059-.117-.118-.236-.177-.355l-.178-.354a3.009,3.009,0,0,1,.191.331,11.294,11.294,0,0,1,.507,1.039c.013.023.024.035.024.06S-1972.647-4678.525-1972.647-4678.512Z",
    transform: "translate(1975.25 4687.44)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31172",
    "data-name": "Path 31172",
    d: "M-1946.435-4687.776l-28.864,4.582c-.011-.024-.023-.036-.035-.059Z",
    transform: "translate(1975.334 4687.776)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28070",
    "data-name": "Group 28070",
    transform: "translate(77.993 33.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31173",
    "data-name": "Path 31173",
    d: "M-1974.754-4682.236v.011l-.011-.011c0-.013,0-.013-.012-.023h.012C-1974.765-4682.249-1974.754-4682.249-1974.754-4682.236Z",
    transform: "translate(1974.777 4682.26)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31174",
    "data-name": "Path 31174",
    d: "M-1974.285-4681.534v.012l-.011-.012Z",
    transform: "translate(1974.756 4682.229)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31175",
    "data-name": "Path 31175",
    d: "M-1974.273-4681.519v.012l-.012-.012Z",
    transform: "translate(1974.756 4682.228)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31176",
    "data-name": "Path 31176",
    d: "M-1973.427-4680.031c-.012-.01-.012-.021-.023-.034-.072-.142-.154-.272-.224-.4a2.993,2.993,0,0,1-.141-.272.013.013,0,0,1-.012-.013h0c-.059-.106-.119-.2-.178-.295l-.106-.178a.193.193,0,0,0,.047.059.2.2,0,0,1,.059.083c.036.047.059.106.1.154a2.018,2.018,0,0,1,.119.2c.1.165.2.342.287.521A.272.272,0,0,1-1973.427-4680.031Z",
    transform: "translate(1974.748 4682.215)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31177",
    "data-name": "Path 31177",
    d: "M-1971.271-4673.719a2.736,2.736,0,0,0-.059-.318c-.024-.166-.059-.332-.1-.5-.011-.06-.024-.13-.035-.192-.023-.083-.035-.178-.059-.272a3.83,3.83,0,0,0-.1-.389c-.024-.106-.058-.213-.082-.319-.012-.023-.012-.046-.024-.071-.024-.083-.048-.177-.071-.272s-.059-.178-.082-.272c-.036-.118-.071-.236-.119-.366v-.022a.039.039,0,0,1-.011-.024c-.011-.046-.035-.1-.048-.154a.522.522,0,0,0-.059-.154,1.866,1.866,0,0,0-.1-.271c-.012-.011-.012-.036-.024-.047-.012-.035-.024-.059-.035-.1a1.149,1.149,0,0,0-.059-.166.794.794,0,0,0-.047-.153l-.013-.013c0-.011,0-.011-.011-.011-.047-.119-.1-.237-.141-.354l-.071-.179a1.216,1.216,0,0,0-.083-.177v-.012c-.105-.237-.212-.484-.33-.722v-.01l-.011-.013c-.059-.118-.118-.236-.177-.355l-.178-.354a2.769,2.769,0,0,1,.192.332,11.217,11.217,0,0,1,.507,1.038.12.12,0,0,1,.024.06c0,.023.012.012.012.023a.779.779,0,0,1,.047.119c.1.2.177.413.259.626.119.286.225.573.32.874.023.083.047.164.071.237.071.2.13.412.191.614.012.059.036.119.048.177.1.355.192.71.259,1.053a6.293,6.293,0,0,1,.119.625.169.169,0,0,1,.011.106.225.225,0,0,1,.024.118A1.7,1.7,0,0,1-1971.271-4673.719Z",
    transform: "translate(1974.717 4682.161)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31178",
    "data-name": "Path 31178",
    d: "M-1971.044-4672.408v.1c-.025-.224-.048-.437-.071-.662-.011-.046-.011-.095-.023-.152l-.036-.308a.4.4,0,0,1,.024.119c0,.035.012.07.012.1a.13.13,0,0,1,.011.06,1.34,1.34,0,0,1,.024.223C-1971.08-4672.751-1971.057-4672.573-1971.044-4672.408Z",
    transform: "translate(1974.622 4681.879)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31179",
    "data-name": "Path 31179",
    d: "M-1970.984-4670.412v.414a.021.021,0,0,1,.006.03l-.006.006v.177c-.012.119-.012.237-.024.355s-.024.225-.034.33c-.012.131-.025.259-.048.39a.507.507,0,0,0-.011.131c-.013.105-.024.212-.036.319a.012.012,0,0,1-.012-.012h0v-.046h-.011v-.048c.047-.259.071-.5.106-.756,0-.034.012-.07.012-.106v-.083c.023-.224.034-.437.047-.661C-1970.984-4670.117-1970.984-4670.283-1970.984-4670.412Z",
    transform: "translate(1974.621 4681.75)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28071",
    "data-name": "Group 28071",
    transform: "translate(78.004 34.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31180",
    "data-name": "Path 31180",
    d: "M-1974.754-4682.232v.012l-.012-.012Z",
    transform: "translate(1974.766 4682.232)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31181",
    "data-name": "Path 31181",
    d: "M-1972.573-4678.256a1.041,1.041,0,0,0-.083-.178h.012Z",
    transform: "translate(1974.675 4682.069)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31182",
    "data-name": "Path 31182",
    d: "M-1972.178-4677.248c-.012-.037-.024-.059-.036-.1a.987.987,0,0,0-.059-.165A1.209,1.209,0,0,1-1972.178-4677.248Z",
    transform: "translate(1974.658 4682.029)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31183",
    "data-name": "Path 31183",
    d: "M-1972-4676.762a.545.545,0,0,0-.059-.153,1.838,1.838,0,0,0-.1-.273c.035.082.059.166.1.248,0,.013.013.013.013.023C-1972.03-4676.868-1972.007-4676.8-1972-4676.762Z",
    transform: "translate(1974.653 4682.015)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31184",
    "data-name": "Path 31184",
    d: "M-1971.721-4675.879c-.024-.083-.059-.178-.082-.271l.01.011C-1971.771-4676.045-1971.745-4675.963-1971.721-4675.879Z",
    transform: "translate(1974.638 4681.97)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31185",
    "data-name": "Path 31185",
    d: "M-1971.24-4673.839v.046c-.024-.164-.059-.331-.1-.5C-1971.3-4674.133-1971.276-4673.981-1971.24-4673.839Z",
    transform: "translate(1974.618 4681.89)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31186",
    "data-name": "Path 31186",
    d: "M-1970.984-4670.412v.414a.021.021,0,0,1,.006.03l-.006.006v.177c-.012.119-.012.237-.024.355s-.024.225-.034.33c-.012.131-.025.259-.048.391a.5.5,0,0,0-.011.13c-.012.105-.024.212-.035.319.035.3.059.591.082.886-.024-.272-.059-.555-.1-.826v-.024h-.011v-.142c.047-.259.071-.5.106-.756,0-.034.012-.07.012-.106v-.082c.023-.224.034-.438.047-.662C-1970.984-4670.117-1970.984-4670.282-1970.984-4670.412Z",
    transform: "translate(1974.611 4681.723)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28072",
    "data-name": "Group 28072",
    transform: "translate(80.709 45.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31187",
    "data-name": "Path 31187",
    d: "M-1971.643-4665.848c-.023.1-.048.193-.071.288v.012c-.071.225-.142.46-.225.7.059-.178.118-.365.166-.542a.8.8,0,0,0,.048-.155C-1971.691-4665.657-1971.666-4665.751-1971.643-4665.848Z",
    transform: "translate(1971.939 4670.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31188",
    "data-name": "Path 31188",
    d: "M-1971.507-4666.278a.011.011,0,0,0-.012.011v-.011Z",
    transform: "translate(1971.921 4670.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31189",
    "data-name": "Path 31189",
    d: "M-1971.348-4666.995c-.012.046-.024.082-.035.131.011-.035.011-.071.024-.119Z",
    transform: "translate(1971.915 4670.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31190",
    "data-name": "Path 31190",
    d: "M-1971.216-4667.734a2.865,2.865,0,0,0-.059.341c-.012.083-.034.166-.048.248a.827.827,0,0,1-.023.1.78.78,0,0,0,.023-.177c.035-.165.059-.33.1-.5Z",
    transform: "translate(1971.914 4670.296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31191",
    "data-name": "Path 31191",
    d: "M-1971.057-4667.294c-.024-.271-.059-.554-.1-.827-.012.106-.036.213-.047.307a.04.04,0,0,0-.012.024c-.012-.024,0-.047.012-.072-.012-.012,0-.022,0-.035a.235.235,0,0,0,.011-.082c0-.024.012-.037.012-.06a.142.142,0,0,0,.012-.072v-.071l.012-.013v-.046a.108.108,0,0,0,.012-.06v-.047a.045.045,0,0,0,.011-.022v-.047a.049.049,0,0,0,.012-.037.063.063,0,0,1,.011-.046c-.011.1-.024.212-.036.319C-1971.1-4667.884-1971.081-4667.589-1971.057-4667.294Z",
    transform: "translate(1971.908 4670.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31192",
    "data-name": "Path 31192",
    d: "M-1970.981-4670.413v.414a.022.022,0,0,1,0,.032l0,0v.177c-.012.119-.012.237-.024.355s-.024.225-.034.33c-.012.131-.024.26-.048.39.011-.142.023-.271.035-.414,0-.035.011-.069.011-.105v-.083c.023-.224.035-.438.047-.661C-1970.981-4670.118-1970.981-4670.283-1970.981-4670.413Z",
    transform: "translate(1971.902 4670.413)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28073",
    "data-name": "Group 28073",
    transform: "translate(61.884 28.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31193",
    "data-name": "Path 31193",
    d: "M-1915.5-4667.346v.011a3.479,3.479,0,0,1-.035.485,3.4,3.4,0,0,1-.13.483,5.06,5.06,0,0,1-2.433,2.657l-43.979,25.557a13.916,13.916,0,0,1-12.66,0l-12.483-7.2-4.393-2.539c1.583-.721,3.095-1.512,4.523-2.339,7.441-4.286,12.27-9.664,14.231-15.365.011-.036.023-.072.036-.106s.024-.059.035-.1c.083-.235.154-.472.226-.7v-.012c.022-.1.048-.191.071-.287a.041.041,0,0,0,.011-.036c0-.013.011-.036.011-.047s.013-.023.013-.036a.276.276,0,0,0,.024-.1c0-.024.011-.059.011-.083s.013-.011.013-.022a.044.044,0,0,1,.011-.024.069.069,0,0,0,.013-.046v-.013a.011.011,0,0,1,.011-.011h0v-.012l.036-.178c.035-.118.058-.236.082-.354v-.011c.011-.047.024-.083.035-.13v-.024a.845.845,0,0,0,.023-.1c.013-.083.035-.165.048-.248a3.173,3.173,0,0,1,.059-.343c-.012-.011-.012-.011,0-.024a.05.05,0,0,1,.012-.022c.011-.1.036-.2.047-.306.035.271.071.555.1.825-.024-.3-.048-.591-.082-.884l.034-.319a.51.51,0,0,1,.011-.131c.023-.129.035-.26.048-.39.011-.106.023-.225.035-.331s.012-.237.024-.354v-.177a.021.021,0,0,0,0-.03l0,0c.011-.226.024-.437.024-.662a5.9,5.9,0,0,0-.036-.792c.012-.024,0-.059,0-.083v-.083a4.321,4.321,0,0,0-.047-.661,5.375,5.375,0,0,0-.083-.744.129.129,0,0,0-.011-.059c0-.036-.012-.07-.012-.106a.384.384,0,0,0-.024-.118,1.724,1.724,0,0,0-.035-.248.236.236,0,0,0-.024-.119.164.164,0,0,0-.012-.106c-.024-.2-.071-.414-.118-.625-.071-.342-.165-.7-.26-1.054-.011-.059-.035-.118-.048-.177-.058-.2-.118-.414-.191-.614-.024-.072-.048-.154-.071-.235-.1-.3-.2-.593-.319-.875-.082-.213-.165-.424-.26-.625-.01-.037-.024-.083-.035-.119h-.012c0-.013,0-.013-.011-.023s-.011-.037-.025-.06a11.565,11.565,0,0,0-.507-1.04,2.886,2.886,0,0,0-.192-.331l-.01-.013a.275.275,0,0,0-.083-.177c-.082-.178-.191-.354-.287-.52a1.864,1.864,0,0,0-.119-.2c-.035-.047-.058-.106-.1-.154-.058-.1-.118-.191-.165-.288l-.025-.022a.167.167,0,0,0-.035-.046.159.159,0,0,0-.036-.046v-.024h-.013v-.012a.2.2,0,0,0-.058-.082.253.253,0,0,0-.048-.072v-.012c-.011-.011-.023-.036-.034-.046a.012.012,0,0,1-.012-.012h0c-.1-.154-.192-.288-.3-.437v0c0-.012-.011-.012-.011-.023h-.012a.068.068,0,0,0-.024-.037.911.911,0,0,0-.1-.13c0-.011-.012-.011-.012-.023a.274.274,0,0,0-.048-.072c0-.011-.012-.023-.024-.035s-.024-.012-.024-.023a.067.067,0,0,0-.033-.048c-.012-.01-.025-.035-.036-.048s0-.011-.01-.021c-.049-.072-.108-.155-.167-.225,0-.013-.011-.023-.023-.034l28.863-4.583,29.005,16.734a7.858,7.858,0,0,1,1.264.92,4.524,4.524,0,0,1,.33.343,1.713,1.713,0,0,1,.2.225,3.86,3.86,0,0,1,.626,1.074,3.382,3.382,0,0,1,.154.484A2.982,2.982,0,0,1-1915.5-4667.346Z",
    transform: "translate(1991.612 4687.774)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31194",
    "data-name": "Path 31194",
    d: "M-1971.349-4667c-.011.047-.024.083-.035.131.012-.036.012-.072.024-.12Z",
    transform: "translate(1990.74 4686.879)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31195",
    "data-name": "Path 31195",
    d: "M-1971.214-4667.734a2.686,2.686,0,0,0-.059.34c.011-.106.035-.213.048-.33Z",
    transform: "translate(1990.735 4686.909)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31196",
    "data-name": "Path 31196",
    d: "M-1971.057-4667.294c-.024-.272-.059-.555-.1-.827-.012.106-.036.213-.047.307a.04.04,0,0,0-.012.025c-.012-.025,0-.047.012-.073-.012-.011,0-.022,0-.035a.235.235,0,0,0,.011-.082c0-.024.012-.036.012-.06a.137.137,0,0,0,.012-.071v-.035h.012c0-.013.012-.022,0-.048v-.045a.108.108,0,0,0,.012-.06.076.076,0,0,0,.011-.07.194.194,0,0,0,.012-.083.068.068,0,0,1,.011-.047c-.011.106-.024.213-.036.319C-1971.1-4667.886-1971.081-4667.589-1971.057-4667.294Z",
    transform: "translate(1990.732 4686.943)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31197",
    "data-name": "Path 31197",
    d: "M-1970.977-4669.943v.177c-.012.119-.012.236-.024.353C-1970.99-4669.589-1970.977-4669.766-1970.977-4669.943Z",
    transform: "translate(1990.723 4687.005)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28074",
    "data-name": "Group 28074",
    transform: "translate(0 30.713)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31198",
    "data-name": "Path 31198",
    d: "M-1918.286-4667.115l-.013,4.665c0,1.322-.873,2.646-2.6,3.649l-43.98,25.556a13.986,13.986,0,0,1-12.661,0l-16.875-9.744-5.751-3.317-53.475-30.883c-1.772-1.017-2.646-2.351-2.646-3.684l.011-4.819a3.274,3.274,0,0,0,.165.992,3.518,3.518,0,0,0,.5.968,4.726,4.726,0,0,0,.378.46,6.414,6.414,0,0,0,1.606,1.264l53.475,30.882,1.746,1,4,2.314,4.394,2.54,12.481,7.2a13.911,13.911,0,0,0,12.661,0l43.979-25.556a5.063,5.063,0,0,0,2.434-2.657,3.271,3.271,0,0,0,.13-.485A1.769,1.769,0,0,0-1918.286-4667.115Z",
    transform: "translate(2056.285 4685.69)",
    fill: "#f5f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31199",
    "data-name": "Path 31199",
    d: "M-1912.069-4666.415v.131a1.842,1.842,0,0,1-.035.354A3.449,3.449,0,0,0-1912.069-4666.415Z",
    transform: "translate(2050.068 4684.86)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28075",
    "data-name": "Group 28075",
    transform: "translate(77.993 33.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31200",
    "data-name": "Path 31200",
    d: "M-1974.754-4682.236h-.011c0-.013,0-.013-.012-.023h.012C-1974.765-4682.249-1974.754-4682.249-1974.754-4682.236Z",
    transform: "translate(1974.777 4682.26)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31201",
    "data-name": "Path 31201",
    d: "M-1974.008-4681.092a.177.177,0,0,0-.059-.082.257.257,0,0,1-.048-.06.087.087,0,0,0-.024-.047.088.088,0,0,1-.023-.047c0-.011-.011-.035-.011-.047A2.738,2.738,0,0,0-1974.008-4681.092Z",
    transform: "translate(1974.751 4682.222)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31202",
    "data-name": "Path 31202",
    d: "M-1973.4-4679.984c-.012-.012-.012-.023-.024-.036a.721.721,0,0,0-.059-.142A.273.273,0,0,1-1973.4-4679.984Z",
    transform: "translate(1974.721 4682.17)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31203",
    "data-name": "Path 31203",
    d: "M-1972.571-4678.33a.755.755,0,0,0-.047-.119h.01C-1972.595-4678.413-1972.583-4678.365-1972.571-4678.33Z",
    transform: "translate(1974.684 4682.096)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31204",
    "data-name": "Path 31204",
    d: "M-1971.015-4671.889v-.06c-.011-.105-.011-.213-.023-.306v-.106a4.16,4.16,0,0,1,.047.662c-.011-.059-.011-.107-.023-.165Z",
    transform: "translate(1974.616 4681.833)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31205",
    "data-name": "Path 31205",
    d: "M-1971.643-4665.846c-.023.1-.048.192-.071.287v.012c-.071.224-.142.461-.225.7.059-.176.118-.365.166-.542a.729.729,0,0,0,.048-.154C-1971.691-4665.656-1971.666-4665.75-1971.643-4665.846Z",
    transform: "translate(1974.655 4681.552)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31206",
    "data-name": "Path 31206",
    d: "M-1971.472-4666.481c-.012.06-.024.119-.035.178v.012a.011.011,0,0,0-.012.012v-.012C-1971.508-4666.346-1971.484-4666.417-1971.472-4666.481Z",
    transform: "translate(1974.636 4681.58)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31207",
    "data-name": "Path 31207",
    d: "M-1971.222-4667.733a3.1,3.1,0,0,0-.059.341c-.012.083-.034.166-.048.248a.854.854,0,0,1-.023.1v.024c-.011.048-.024.084-.035.131v.012c-.024.118-.048.236-.082.354.047-.236.1-.472.141-.7.035-.166.059-.33.1-.5Z",
    transform: "translate(1974.635 4681.633)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31208",
    "data-name": "Path 31208",
    d: "M-1970.962-4670.707c0,.224-.011.436-.024.66a.022.022,0,0,1,0,.031l0,0v.179c-.011.119-.011.236-.024.353s-.023.225-.035.332c-.011.13-.025.26-.047.39a.47.47,0,0,0-.011.128c-.012.106-.024.213-.036.319.036.3.059.592.082.886-.024-.273-.059-.555-.1-.826-.012.105-.036.212-.047.307a.034.034,0,0,0-.012.023.083.083,0,0,1,.012-.072c-.012-.011,0-.023,0-.036a.232.232,0,0,0,.011-.082c0-.024.012-.036.012-.06a.137.137,0,0,0,.012-.071v-.178c.047-.259.071-.5.106-.756,0-.035.012-.071.012-.106v-.082c.023-.225.035-.438.047-.662.011-.141.011-.307.011-.436v-.226c0-.271,0-.542-.011-.813A5.8,5.8,0,0,1-1970.962-4670.707Z",
    transform: "translate(1974.623 4681.795)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31209",
    "data-name": "Path 31209",
    d: "M-1912.069-4666.414v.13a1.834,1.834,0,0,1-.035.354A3.436,3.436,0,0,0-1912.069-4666.414Z",
    transform: "translate(1972.075 4681.577)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28076",
    "data-name": "Group 28076",
    transform: "translate(77.993 33.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31210",
    "data-name": "Path 31210",
    d: "M-1974.754-4682.236v.011l-.011-.011c0-.013,0-.013-.012-.023h.012C-1974.765-4682.249-1974.754-4682.249-1974.754-4682.236Z",
    transform: "translate(1974.777 4682.26)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31211",
    "data-name": "Path 31211",
    d: "M-1974.288-4681.535v.012l-.012-.012a.2.2,0,0,0-.048-.083A.2.2,0,0,1-1974.288-4681.535Z",
    transform: "translate(1974.758 4682.232)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31212",
    "data-name": "Path 31212",
    d: "M-1974.273-4681.519v.012l-.012-.012Z",
    transform: "translate(1974.756 4682.228)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31213",
    "data-name": "Path 31213",
    d: "M-1971.636-4665.846c-.023.1-.048.192-.07.287v.012c-.025.047-.036.106-.059.154a.816.816,0,0,0,.048-.154C-1971.684-4665.656-1971.659-4665.75-1971.636-4665.846Z",
    transform: "translate(1974.647 4681.552)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31214",
    "data-name": "Path 31214",
    d: "M-1971.508-4666.278a.011.011,0,0,0-.011.011v-.011Z",
    transform: "translate(1974.636 4681.571)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31215",
    "data-name": "Path 31215",
    d: "M-1971.349-4666.995c-.011.047-.024.083-.035.131.012-.035.012-.071.024-.119Z",
    transform: "translate(1974.631 4681.602)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31216",
    "data-name": "Path 31216",
    d: "M-1973.429-4680.034c-.011-.011-.011-.022-.024-.035-.071-.143-.154-.273-.224-.4-.051-.088-.1-.179-.141-.273a.012.012,0,0,1-.012-.012h0c-.059-.105-.117-.2-.177-.294l-.106-.178a.082.082,0,0,0-.024-.048.083.083,0,0,1-.023-.046.1.1,0,0,1-.036-.072l.025.023c.048.1.106.192.165.288.036.046.059.105.1.154a2,2,0,0,1,.119.2c.1.166.2.342.287.52A.273.273,0,0,1-1973.429-4680.034Z",
    transform: "translate(1974.752 4682.223)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31217",
    "data-name": "Path 31217",
    d: "M-1971.1-4668.5c-.012.105-.024.212-.036.318,0,.013-.013.022-.013.036v.023c-.011.106-.036.212-.047.308a.043.043,0,0,0-.011.024.081.081,0,0,1,.011-.071c-.011-.011,0-.023,0-.035a.241.241,0,0,0,.011-.083c0-.023.012-.036.012-.06a.145.145,0,0,0,.012-.072v-.07l.011-.013v-.046a.108.108,0,0,0,.013-.06v-.046a.145.145,0,0,0,.011-.071.045.045,0,0,0,.011-.037A.065.065,0,0,1-1971.1-4668.5Z",
    transform: "translate(1974.623 4681.666)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31218",
    "data-name": "Path 31218",
    d: "M-1971.329-4674.085c-.036-.14-.059-.3-.1-.449-.011-.06-.024-.13-.035-.191-.023-.083-.035-.178-.059-.272a3.847,3.847,0,0,0-.1-.39c-.024-.106-.058-.212-.082-.318-.013-.024-.013-.047-.024-.071-.024-.082-.048-.178-.071-.272s-.048-.165-.071-.259l-.011-.012c-.036-.118-.071-.236-.118-.366v-.022a.04.04,0,0,1-.012-.024c-.012-.046-.034-.1-.048-.154a.528.528,0,0,0-.059-.154,1.867,1.867,0,0,0-.1-.271c-.012-.011-.012-.036-.024-.047-.012-.035-.024-.059-.035-.1a1.121,1.121,0,0,0-.059-.166.859.859,0,0,0-.047-.153l-.012-.013c0-.011,0-.011-.012-.011-.047-.119-.1-.237-.142-.354l-.071-.179-.071-.177h-.012v-.012c-.105-.237-.211-.484-.33-.722v-.01l-.011-.013-.177-.355-.178-.354a2.8,2.8,0,0,1,.191.332,11.311,11.311,0,0,1,.507,1.038.121.121,0,0,1,.024.06c0,.023.011.012.011.023h.012c.011.035.025.083.035.119.1.2.177.413.259.626.119.286.225.573.32.874.023.083.047.164.071.237.071.2.13.412.191.614.011.059.036.119.048.177.1.355.191.71.259,1.053a6.258,6.258,0,0,1,.119.625A.165.165,0,0,1-1971.329-4674.085Z",
    transform: "translate(1974.717 4682.161)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31219",
    "data-name": "Path 31219",
    d: "M-1971.178-4673.451a2.755,2.755,0,0,0-.058-.319v-.047a.231.231,0,0,1,.024.119A1.74,1.74,0,0,1-1971.178-4673.451Z",
    transform: "translate(1974.624 4681.896)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31220",
    "data-name": "Path 31220",
    d: "M-1971.021-4671.938v-.06c-.011-.105-.011-.211-.023-.306v-.012c-.025-.224-.048-.437-.071-.661-.011-.047-.011-.1-.023-.153l-.036-.307a.4.4,0,0,1,.024.118c0,.036.012.07.012.106a.123.123,0,0,1,.011.059,1.357,1.357,0,0,1,.024.225c.024.177.048.354.059.52a4.376,4.376,0,0,1,.047.66c-.013-.06-.013-.106-.024-.166Z",
    transform: "translate(1974.622 4681.879)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31221",
    "data-name": "Path 31221",
    d: "M-1970.957-4670.708c0,.224-.012.437-.024.661a.021.021,0,0,1,0,.03l0,0v.179c-.012.119-.012.236-.024.353s-.024.225-.034.332c-.012.131-.024.259-.048.39.011-.142.023-.272.035-.414,0-.036.011-.071.011-.106v-.083c.023-.224.035-.437.047-.661.011-.141.011-.308.011-.437v-.225c0-.271,0-.542-.011-.813A5.877,5.877,0,0,1-1970.957-4670.708Z",
    transform: "translate(1974.618 4681.795)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28077",
    "data-name": "Group 28077",
    transform: "translate(0.013 15.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31222",
    "data-name": "Path 31222",
    d: "M-1978.823-4683.839l-3.909.615-3.141.5-14.277,30.931-53.476-30.882a6.447,6.447,0,0,1-1.606-1.265,4.4,4.4,0,0,1-.377-.459,3.419,3.419,0,0,1-.5-.968,3.257,3.257,0,0,1-.166-.993c0-1.311.861-2.633,2.6-3.636l18.518-10.77a89.621,89.621,0,0,1,13.557-.5l-5.2,2.987a1.209,1.209,0,0,0-.756,1v.792c.13-.012.272-.012.413-.012a1.869,1.869,0,0,0,.237.176l.106.059,2.4,1.407,10.2,5.977a3.692,3.692,0,0,0,3.389-.047l5.715-3.272,2.316-1.322h.012a.279.279,0,0,1,.1.024.267.267,0,0,1,.1.023v-.165a1.866,1.866,0,0,0,.287-.213,1.048,1.048,0,0,0,.191-.2.033.033,0,0,0,.012-.023,1.612,1.612,0,0,0,.13-.236v-.012a.876.876,0,0,0,.048-.248v-.013a1.172,1.172,0,0,0-.65-.957l-7.735-4.523a64.262,64.262,0,0,1,20.86,7.228A34.955,34.955,0,0,1-1978.823-4683.839Z",
    transform: "translate(2056.271 4701.337)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31223",
    "data-name": "Path 31223",
    d: "M-2025.843-4696.319c-.142,0-.287,0-.413.013v-.793a.665.665,0,0,0,.036.213.223.223,0,0,0,.024.1.949.949,0,0,0,.1.191c.012.012.012.023.024.023a.473.473,0,0,0,.119.142A.557.557,0,0,0-2025.843-4696.319Z",
    transform: "translate(2054.977 4701.155)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31224",
    "data-name": "Path 31224",
    d: "M-2000.162-4693.295v.165a.266.266,0,0,0-.1-.023.29.29,0,0,0-.1-.024l.1-.059A.811.811,0,0,0-2000.162-4693.295Z",
    transform: "translate(2053.86 4700.991)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28078",
    "data-name": "Group 28078",
    transform: "translate(77.484 34.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31225",
    "data-name": "Path 31225",
    d: "M-1974.754-4682.232v.012l-.012-.012Z",
    transform: "translate(1975.285 4682.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31226",
    "data-name": "Path 31226",
    d: "M-1974.009-4681.047l-.106-.178a.187.187,0,0,0,.047.06A.539.539,0,0,0-1974.009-4681.047Z",
    transform: "translate(1975.257 4682.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31227",
    "data-name": "Path 31227",
    d: "M-1975.3-4678.027v.1c0-.014,0-.024-.011-.024v-.059Z",
    transform: "translate(1975.309 4682.051)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31228",
    "data-name": "Path 31228",
    d: "M-1972.055-4676.939v.023a1.838,1.838,0,0,0-.1-.273C-1972.114-4677.1-1972.09-4677.021-1972.055-4676.939Z",
    transform: "translate(1975.172 4682.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31229",
    "data-name": "Path 31229",
    d: "M-1971.993-4676.752a.553.553,0,0,0-.059-.152h.012C-1972.027-4676.856-1972-4676.8-1971.993-4676.752Z",
    transform: "translate(1975.169 4682.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31230",
    "data-name": "Path 31230",
    d: "M-1971.472-4666.481c-.012.06-.024.119-.035.178v.012h-.012C-1971.508-4666.345-1971.484-4666.417-1971.472-4666.481Z",
    transform: "translate(1975.145 4681.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31231",
    "data-name": "Path 31231",
    d: "M-1971.222-4667.734a3,3,0,0,0-.059.34c-.012.083-.034.165-.048.248a.734.734,0,0,1-.023.1v.024l-.011.012c-.012.048-.012.083-.024.119v.013c-.023.118-.048.236-.082.354.048-.236.1-.472.141-.7.036-.165.059-.33.1-.5Z",
    transform: "translate(1975.144 4681.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31232",
    "data-name": "Path 31232",
    d: "M-1971.2-4667.833v.047a.041.041,0,0,0-.012.023C-1971.224-4667.786-1971.211-4667.809-1971.2-4667.833Z",
    transform: "translate(1975.132 4681.612)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31233",
    "data-name": "Path 31233",
    d: "M-1971.055-4669.066c-.012.141-.024.271-.035.415a.485.485,0,0,0-.011.128.077.077,0,0,0-.013.047.041.041,0,0,1-.011.036.155.155,0,0,1-.012.072v.046a.1.1,0,0,1-.012.06v.047l-.011.012v-.106C-1971.114-4668.571-1971.09-4668.807-1971.055-4669.066Z",
    transform: "translate(1975.13 4681.665)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28164",
    "data-name": "Group 28164",
    transform: "translate(911.964 387.421)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28160",
    "data-name": "Group 28160",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28157",
    "data-name": "Group 28157",
    transform: "translate(35.239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31431",
    "data-name": "Path 31431",
    d: "M-2181.921-4713.609l-7.719,4.492c.368-.213.472-.854.137-1.615l-34.538-84.141a2.445,2.445,0,0,0-.942-1.113.82.82,0,0,0-.816-.081l7.718-4.486a.8.8,0,0,1,.816.084,2.414,2.414,0,0,1,.948,1.111l34.533,84.134C-2181.445-4714.458-2181.554-4713.823-2181.921-4713.609Z",
    transform: "translate(2225.799 4800.632)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_185",
    "data-name": "Union 185",
    d: "M70.582,86.94,1.149,46.856c-.927-.538-1.471-2.051-.941-2.625L35.105.183A.734.734,0,0,1,36.055.16,2.429,2.429,0,0,1,37,1.275L71.532,85.41c.418.94.157,1.691-.432,1.691A1.045,1.045,0,0,1,70.582,86.94Zm-8.261-9.488c.458.264.778.018.78-.443,0,.461-.322.706-.78.44L9.433,46.916ZM63.1,77v0Zm0-.049c0-.014,0-.028,0-.042C63.1,76.926,63.1,76.94,63.1,76.953Zm0-.055c0-.012,0-.025,0-.037C63.092,76.874,63.093,76.886,63.1,76.9Zm-.006-.047-.006-.043Zm-.011-.066-.006-.03Zm-.014-.066a.13.13,0,0,1,0-.019A.13.13,0,0,0,63.065,76.72Zm-.02-.073h0Zm-.014-.043a.089.089,0,0,1,0-.015A.089.089,0,0,0,63.031,76.6ZM36.018,12.626a2.361,2.361,0,0,1,.937,1.134l26,62.653c.012.027.023.053.034.079-.011-.026-.022-.053-.034-.079l-26-62.653a2.381,2.381,0,0,0-.94-1.134ZM33.255,53.02a6.044,6.044,0,0,0,2.671,4.607c.059.033.119.066.178.1,1.451.726,2.384-.013,2.44-1.639A6.025,6.025,0,0,0,35.877,51.2a3.313,3.313,0,0,0-.343-.171,2.147,2.147,0,0,0-.836-.191C33.794,50.834,33.216,51.618,33.255,53.02Zm.607-30.761.5,22.121a3.453,3.453,0,0,0,1.563,2.658c.848.488,1.544.115,1.574-.847l.617-21.475A2.219,2.219,0,0,0,37.1,22.931l-2.218-1.283a.923.923,0,0,0-.455-.139C34.086,21.509,33.854,21.786,33.862,22.258Zm1.217-9.58Z",
    transform: "translate(0 4.487)",
    fill: "#fa951b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28163",
    "data-name": "Group 28163",
    transform: "translate(33.253 25.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28161",
    "data-name": "Group 28161",
    transform: "translate(0 29.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31434",
    "data-name": "Path 31434",
    d: "M-2226.8-4699.28a6.03,6.03,0,0,1,2.668,4.887c-.057,1.625-.99,2.364-2.443,1.638-.059-.03-.116-.061-.174-.1a6.037,6.037,0,0,1-2.675-4.6c-.046-1.8.915-2.579,2.28-2A2.633,2.633,0,0,1-2226.8-4699.28Z",
    transform: "translate(2229.427 4699.642)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28162",
    "data-name": "Group 28162",
    transform: "translate(0.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31435",
    "data-name": "Path 31435",
    d: "M-2226.251-4727.646a3.458,3.458,0,0,1-1.565-2.659l-.494-22.116c-.013-.664.446-.943,1.017-.614l2.221,1.282a2.224,2.224,0,0,1,1.011,1.783l-.618,21.476C-2224.706-4727.53-2225.405-4727.158-2226.251-4727.646Z",
    transform: "translate(2228.31 4753.174)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCard);
export default __webpack_public_path__ + "static/media/report_card.ad0497e55a990e2a96051e192b9d2abe.svg";
export { ForwardRef as ReactComponent };